import { axiosInstance } from '~/services';

import type { TypePostUserLoginSendTwoFactorCodeParams } from '~/types/auth.types';
import type { TypeErrorResponseData } from '~/types/common.types';

/**
 * 로그인 2단계 메일 요청 API
 */
const usePostUserLoginSendTwoFactorCode = () => {
  const endPoint = '/api-owner/user/login/send/twofactor-code';

  const postUserLoginSendTwoFactorCode = async (params: TypePostUserLoginSendTwoFactorCodeParams) => {
    return axiosInstance
      .post(endPoint, params)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postUserLoginSendTwoFactorCode };
};

export default usePostUserLoginSendTwoFactorCode;
